import { Vue, i18n } from "Components/vue"

import Autocomplete from './../components/vue/Autocomplete.vue';

const $autocompleteElem = document.querySelector('#autocomplete');

if ($autocompleteElem) {
    window.$_autocomplete = new Vue({
        i18n,
        render: h => h(Autocomplete)
    }).$mount("#autocomplete");
}

// document.querySelector('.js-trigger-search').addEventListener('click', event => {
//     event.preventDefault();

//     rEvent.dispatch("Autocomplete.showForm");
// });